module.exports = __webpack_public_path__ + "assets/img/A5-2.4e1968ad.jpg";